import React from 'react';

import i18n from '@yandex-int/i18n';
import clx from 'classnames';
import { NdaLink } from 'client/blocks-redesign/NdaLink/NdaLink';
import { moment } from 'client/lib/moment';
import { routes } from 'client/lib/routes';
import * as keyset from 'i18n/AppsIndex';
import * as footerKeyset from 'i18n/Footer';

import styles from './Footer.module.scss';

const t = i18n(keyset);
const tFooter = i18n(footerKeyset);

export const Footer = () => {
    return (
        <footer className={styles.footer}>
            <a
                className={clx(styles.footer__element, styles.footer__element_link)}
                href={routes.documentation.index}
                rel="noopener noreferrer"
            >
                {t('docs')}
            </a>
            <a
                className={clx(styles.footer__element, styles.footer__element_link)}
                href={routes.documentation.aliceSkills.feedback}
                rel="noopener noreferrer"
            >
                {t('feedback')}
            </a>
            <a
                className={clx(styles.footer__element, styles.footer__element_link)}
                href={routes.documentation.termsOfUse}
                rel="noopener noreferrer"
            >
                {tFooter('terms-of-use')}
            </a>
            <span className={clx(styles.footer__element, styles.footer__element_text)}>
                <NdaLink />
                {t('yandex-copyright', { year: moment().year() })}
            </span>
        </footer>
    );
};
